import {useNavigate, useParams} from "react-router-dom";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import {IMAGE_URL} from "../path";
import {useEffect, useState} from "react";
import {getPodcast} from "../actions/ApiCalls";
import './styles.css'

// Add this style block at the top of your component
const globalStyles = `
  a {
    color: black !important;
    text-decoration: underline;



  }
`;

function Podcast() {
    const { slug } = useParams<{ slug?: string }>();
    const [podcast, setPodcast] = useState<any>(null);
    const [recommendations, setRecommendations] = useState<any[]>([])
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isLibsyn =
        podcast?.podcast?.includes("html5-player.libsyn.com") ||
        podcast?.podcast?.includes("open.spotify.com/embed");
    // const isYouTube =
    //     podcast?.podcast?.includes("youtube.com") ||
    //     podcast?.podcast?.includes("youtu.be") ||
    //     podcast?.podcast?.includes("youtube-nocookie.com");


    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (slug) {
            getPodcast(slug)
                .then(response => {
                    setPodcast(response.data.data.podcast);

                    setRecommendations(response.data.data.recommendations);
                    window.document.title =   response.data.data.podcast?.seo_meta_title;
                })
                .catch(error => {
                    console.error("Failed to fetch podcast:", error);
                });
        }

    }, [slug]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isDesktop = windowWidth > 575;
    const isMobile = !isDesktop;

    const getModifiedIframeHTML = (html: string) => {
        if (!html || !isMobile) return html;

        // Extract original width and height to calculate aspect ratio
        const widthMatch = html.match(/width="([^"]*)"/);
        const heightMatch = html.match(/height="([^"]*)"/);

        if (widthMatch && heightMatch) {
            const originalWidth = parseInt(widthMatch[1]);
            const originalHeight = parseInt(heightMatch[1]);
            const aspectRatio = originalHeight / originalWidth;

            const newWidth = Math.min(windowWidth - 40, 800); // Account for padding and max width
            const newHeight = Math.round(newWidth * aspectRatio);

            // Replace width and height attributes maintaining original aspect ratio
            const modifiedHTML = html
                .replace(/width="[^"]*"/g, `width="${newWidth}"`)
                .replace(/height="[^"]*"/g, `height="${newHeight}"`);

            return modifiedHTML;
        }

        // Fallback to original behavior if width/height not found
        const newWidth = Math.min(windowWidth - 40, 800);
        const modifiedHTML = html
            .replace(/width="[^"]*"/g, `width="${newWidth}"`)
            .replace(/height="[^"]*"/g, `height="${Math.round(newWidth * 9 / 16)}"`);

        return modifiedHTML;
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>

            <style>{globalStyles}</style>
            <Header />
            <div>
                <div>
                    <div style={{display: 'flex', flexDirection: isDesktop ? 'row' : 'column', marginTop: isMobile ? '100px' : '140px'}}>
                        <div style={{flex: 1}}>

                        </div>
                        <div style={{flex: 1, textAlign: 'left', marginLeft: isMobile ? '24px' : '50px'}}>
                            <p><a className="link-styles"
                                  onClick={() => navigate('/podcasts')}>BACK to podcasts</a></p>
                        </div>
                    </div>


                    {isLibsyn ? (
                        <>
                            {/* Mobile Layout: Image first, then content */}
                            {!isDesktop && (
                                <>
                                    <div style={{
                                        marginTop: '50px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        paddingRight: window.innerWidth > 575 ? '0' : 0
                                    }}>
                                        <img style={{
                                            width: '100%',
                                            maxWidth: '100%',
                                            objectFit: 'contain',
                                            height: 'auto'
                                        }} src={IMAGE_URL + podcast?.image} alt={podcast?.title} />
                                    </div>
                                    <div style={{
                                        marginTop: '20px',
                                        width: '90%',
                                        margin: isMobile ? '24px' : '20px auto 0',
                                        textAlign: 'left',
                                    }}>
                                        <div style={{borderRadius: '4px', marginBottom: '20px'}}>
                                            <p style={{ fontWeight: 600, marginTop: 0, textTransform: 'uppercase' }}>{podcast?.title}</p>
                                            <p style={{ fontWeight: 600, fontSize: '10px', lineHeight: '13px'}}>
                                                {podcast?.created_at ? new Date(podcast?.created_at).toISOString().split("T")[0] : ""}
                                            </p>
                                            <div dangerouslySetInnerHTML={{ __html: podcast?.content }} />
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Desktop Layout: Side by side */}
                            {isDesktop && (
                                <div
                                    style={{
                                        marginTop: '100px',
                                        display: 'flex',
                                        flexDirection: 'row',


                                        alignItems: 'flex-start'
                                    }}
                                >
                                    <div style={{flex: 1,  display: 'flex', justifyContent: 'flex-end'}}>
                                        <div style={{ }}>
                                            <img style={{
                                                maxHeight: '515px',
                                                maxWidth: 'calc(50vw - 34px)',
                                                objectFit: 'contain',
                                                height: 'auto',
                                                width: 'auto',
                                                marginRight: '-30px'
                                            }} src={IMAGE_URL + podcast?.image} alt={podcast?.title} />
                                        </div>
                                    </div>
                                    <div style={{ flex: 1, textAlign: 'left', minHeight: '600px', marginLeft: '50px'}}>
                                        <div style={{width: '60%', borderRadius: '4px', marginBottom: '20px'}}>
                                            <p style={{ fontWeight: 600, marginTop: 0, textTransform: 'uppercase' }}>{podcast?.title}</p>
                                            <p style={{ fontWeight: 600, fontSize: '10px', lineHeight: '13px'}}>
                                                {podcast?.created_at ? new Date(podcast?.created_at).toISOString().split("T")[0] : ""}
                                            </p>
                                            <div dangerouslySetInnerHTML={{ __html: podcast?.content }} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '72px'
                            }}>
                                {podcast?.podcast && (
                                    <div
                                        style={{
                                            width: '100%',
                                            maxWidth: '800px'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: getModifiedIframeHTML(podcast.podcast) }}
                                    />
                                )}
                            </div>
                        </>
                    ): (
                        <>
                            {isMobile ? (
                                <div style={{ marginTop: '50px' }}>
                                    <div
                                        style={{
                                            width: '100vw',
                                            aspectRatio: '16/9',
                                            marginBottom: '20px',
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: getModifiedIframeHTML(podcast?.podcast)
                                        }}
                                    />

                                    <div
                                        style={{
                                            textAlign: 'left',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '90%',
                                                marginBottom: '20px',
                                                marginLeft: '24px'
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontWeight: 600,
                                                    marginTop: 0,
                                                    textTransform: 'uppercase'
                                                }}
                                            >
                                                {podcast?.title}
                                            </p>

                                            <p
                                                style={{
                                                    fontWeight: 600,
                                                    fontSize: '10px',
                                                    lineHeight: '13px'
                                                }}
                                            >
                                                {podcast?.created_at
                                                    ? new Date(podcast.created_at)
                                                        .toISOString()
                                                        .split("T")[0]
                                                    : ""}
                                            </p>

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: podcast?.content
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        marginTop: '100px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        paddingRight: '20px',
                                        marginLeft: '56px'
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    aspectRatio: '16/9'
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: podcast?.podcast
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            flex: 1,
                                            textAlign: 'left',
                                            marginLeft: '16px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '70%',
                                                marginBottom: '20px'
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontWeight: 600,
                                                    marginTop: 0,
                                                    textTransform: 'uppercase'
                                                }}
                                            >
                                                {podcast?.title}
                                            </p>

                                            <p
                                                style={{
                                                    fontWeight: 600,
                                                    fontSize: '10px',
                                                    lineHeight: '13px'
                                                }}
                                            >
                                                {podcast?.created_at
                                                    ? new Date(podcast.created_at)
                                                        .toISOString()
                                                        .split("T")[0]
                                                    : ""}
                                            </p>

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: podcast?.content
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}


                    {recommendations.length > 0 && (
                        <div style={{
                            marginTop: '60px',
                            padding: '20px'
                        }}>
                            <p style={{
                                marginBottom: '20px',
                                fontWeight: 400,
                                textAlign: 'left',
                                fontFamily: "'Vinimark-Diatype', sans-serif",

                            }}>
                                More Podcasts
                            </p>
                            <div style={{
                                display: 'flex',
                                gap: '20px',
                                // overflowX: 'scroll',
                                overflowY: 'scroll',
                                paddingBottom: '10px'
                            }}>
                                {recommendations.map((recommendation, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            cursor: 'pointer',
                                            textAlign: 'center',
                                            flex: '1 1 135px',
                                            width: '25vw',
                                            minWidth: '135px'

                                        }}
                                        onClick={() => navigate(`/podcasts/${recommendation.search_name}`)}
                                    >
                                        <img
                                            src={IMAGE_URL + recommendation.image}
                                            alt={recommendation.title}
                                            style={{
                                                width: '100%',
                                                minWidth: '135px',
                                                aspectRatio: '1/1',
                                                objectFit: 'cover',
                                            }}
                                        />
                                        <p style={{
                                            marginTop: '10px',
                                            fontWeight: 600,
                                            fontSize: '13px',
                                            fontFamily: "'Vinimark-Diatype', sans-serif",
                                            textTransform: 'uppercase',
                                            textAlign: "left"
                                        }}>
                                            {recommendation.title}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Podcast;
